<index-button type="secondary"
              class="w-full mx-auto btn-download"
              iconLeft
              (click)="this.handleDownloadClick()">
  <index-icon name="arrow-to-bottom"
              size="small"></index-icon>
  {{ 'Download' | transloco }}
</index-button>
